export const layoutStyles = {
  wrapper: {
    display: 'flex',
    height: '100vh',
    backgroundColor: '#0D0D0D',
    color: '#FFFFFF',
    overflow: 'hidden',
  },
  sidebar: {
    width: '260px',
    minWidth: '260px',
    borderRight: '1px solid #2D2D2D',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    height: '100vh',
    overflowY: 'auto',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    position: 'relative',
  },
  chatContainer: {
    flex: 1,
    overflowY: 'auto',
    paddingBottom: '120px',
    height: 'calc(100vh - 60px)',
  },
  inputArea: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '20px',
    backgroundColor: '#0D0D0D',
    borderTop: '1px solid #2D2D2D',
  },
  navbar: {
    height: '60px',
    minHeight: '60px',
    borderBottom: '1px solid #2D2D2D',
    padding: '0 20px',
    display: 'flex',
    alignItems: 'center',
  },
} as const; 